/**
 * Modular What's New entries for the "statistics" module. `routes` use the real navigation screen
 * name from AppNavigator.jsx.
 *
 * @type {Object[]}
 */
const statisticsEntries = [
  {
    id: 'statistics-date-picker-stability-2026-10',
    module: 'statistics',
    routes: ['StatisticsScreen'],
    date: '2026-10-18',
    version: '4.15.1',
    global: true,
    type: 'fix',
    title: {
      en: "🛠️ Statistics: picking a day works even on a weak connection",
      hu: "🛠️ Statisztika: a nap kiválasztása gyenge kapcsolaton is működik",
      de: "🛠️ Statistik: Tagesauswahl klappt auch bei schwacher Verbindung",
      cn: "🛠️ 统计：网络较差时也能正常选择日期",
      ro: "🛠️ Statistici: alegerea unei zile merge și pe o conexiune slabă",
      svn: "🛠️ Statistika: izbira dneva deluje tudi ob šibki povezavi",
    },
    body: {
      en: "When the orders of the chosen day could not be loaded, the statistics screen could get stuck with an error. It now simply shows an empty day and you can try again. The date picker also speaks your language instead of falling back to English.",
      hu: "Ha a kiválasztott nap rendeléseit nem sikerült betölteni, a statisztika képernyő hibával elakadhatott. Most egyszerűen üres napot mutat, és újrapróbálhatod. A dátumválasztó is a te nyelveden jelenik meg angol helyett.",
      de: "Konnten die Bestellungen des gewählten Tages nicht geladen werden, blieb der Statistik-Bildschirm mit einem Fehler hängen. Jetzt zeigt er einfach einen leeren Tag, und Sie können es erneut versuchen. Auch die Datumsauswahl spricht jetzt Ihre Sprache statt Englisch.",
      cn: "当所选日期的订单无法加载时，统计页面可能卡在错误状态。现在它会直接显示空白的一天，你可以重试。日期选择器也会使用你的语言，而不是默认英文。",
      ro: "Când comenzile zilei alese nu se puteau încărca, ecranul de statistici se putea bloca cu o eroare. Acum afișează pur și simplu o zi goală și poți încerca din nou. Selectorul de dată vorbește și el limba ta, nu engleza.",
      svn: "Ko naročil izbranega dne ni bilo mogoče naložiti, se je zaslon statistike lahko ustavil z napako. Zdaj preprosto prikaže prazen dan in lahko poskusite znova. Tudi izbirnik datuma je zdaj v vašem jeziku namesto v angleščini.",
    },
  },
];

export default statisticsEntries;
